import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicoNormativasPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#1A3A5F] to-[#4D8BC9] text-white">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Serviços de Normativas Técnicas</h1>
            <p className="text-xl mb-8">
              Consultoria especializada para garantir conformidade com normas e regulamentos técnicos
            </p>
          </motion.div>
        </div>
      </section>

      {/* Introdução */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Normativas Técnicas</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              As normativas técnicas são documentos que estabelecem regras, diretrizes ou características para 
              atividades ou seus resultados, visando a obtenção de um grau ótimo de ordenação em um dado contexto. 
              Nossa equipe especializada oferece serviços de consultoria para garantir que sua empresa esteja em 
              conformidade com as normas e regulamentos aplicáveis ao seu setor.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Importância das Normativas</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Garantia de segurança operacional</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Conformidade legal e regulatória</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Padronização de processos e produtos</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Melhoria contínua da qualidade</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Redução de riscos e responsabilidades</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Facilitação do comércio nacional e internacional</span>
                </li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Nossa Abordagem</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Equipe de especialistas em normas técnicas</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Análise personalizada para cada cliente</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Acompanhamento contínuo das atualizações normativas</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Implementação prática das exigências normativas</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Treinamento e capacitação de equipes</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span>Suporte técnico especializado</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Principais Normativas */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Principais Normativas</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Oferecemos serviços especializados para as principais normas regulamentadoras e técnicas 
              aplicáveis aos diversos setores industriais.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* NR-13 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">NR-13: Caldeiras, Vasos de Pressão e Tubulações</h3>
              <p className="text-gray-700 mb-4">
                Estabelece requisitos mínimos para gestão da integridade estrutural de caldeiras, vasos de pressão 
                e suas tubulações de interligação nos aspectos relacionados à instalação, inspeção, operação e manutenção.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Elaboração de prontuário</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Inspeção de segurança inicial</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Inspeção de segurança periódica</span>
                </li>
              </ul>
              <Link to="/normativas/nr13" className="text-[#4D8BC9] hover:text-[#1A3A5F] font-medium transition-colors">
                Saiba mais sobre NR-13 →
              </Link>
            </motion.div>

            {/* NR-11 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">NR-11: Transporte, Movimentação, Armazenagem e Manuseio de Materiais</h3>
              <p className="text-gray-700 mb-4">
                Estabelece os requisitos de segurança para operações de transporte, movimentação, armazenagem 
                e manuseio de materiais, tanto de forma mecânica quanto manual.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Inspeção de equipamentos de movimentação</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Elaboração de procedimentos operacionais</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Treinamento de operadores</span>
                </li>
              </ul>
              <Link to="/normativas/nr11" className="text-[#1A3A5F] hover:text-[#4D8BC9] font-medium transition-colors">
                Saiba mais sobre NR-11 →
              </Link>
            </motion.div>

            {/* NR-20 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">NR-20: Segurança e Saúde no Trabalho com Inflamáveis e Combustíveis</h3>
              <p className="text-gray-700 mb-4">
                Estabelece requisitos mínimos para a gestão da segurança e saúde no trabalho contra os fatores 
                de risco de acidentes provenientes das atividades com inflamáveis e combustíveis.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Análise de riscos</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Plano de resposta a emergências</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Capacitação dos trabalhadores</span>
                </li>
              </ul>
              <Link to="/normativas/nr20" className="text-[#4D8BC9] hover:text-[#1A3A5F] font-medium transition-colors">
                Saiba mais sobre NR-20 →
              </Link>
            </motion.div>

            {/* NR-33 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">NR-33: Segurança e Saúde nos Trabalhos em Espaços Confinados</h3>
              <p className="text-gray-700 mb-4">
                Estabelece os requisitos para identificação de espaços confinados e o reconhecimento, avaliação, 
                monitoramento e controle dos riscos existentes nesses ambientes.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Identificação e cadastro de espaços confinados</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Elaboração de procedimentos de entrada</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Treinamento de equipes</span>
                </li>
              </ul>
              <Link to="/normativas/nr33" className="text-[#1A3A5F] hover:text-[#4D8BC9] font-medium transition-colors">
                Saiba mais sobre NR-33 →
              </Link>
            </motion.div>

            {/* NR-35 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">NR-35: Trabalho em Altura</h3>
              <p className="text-gray-700 mb-4">
                Estabelece os requisitos mínimos e as medidas de proteção para o trabalho em altura, 
                envolvendo o planejamento, a organização e a execução.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Análise de risco e permissão de trabalho</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Sistemas de proteção contra quedas</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#4D8BC9] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Capacitação e treinamento</span>
                </li>
              </ul>
              <Link to="/normativas/nr35" className="text-[#4D8BC9] hover:text-[#1A3A5F] font-medium transition-colors">
                Saiba mais sobre NR-35 →
              </Link>
            </motion.div>

            {/* Outras Normas */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Outras Normas e Regulamentos</h3>
              <p className="text-gray-700 mb-4">
                Além das normas regulamentadoras, oferecemos serviços para diversas outras normas 
                técnicas nacionais e internacionais.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4">
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Normas ABNT</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Normas API, ASME, ASTM</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-5 w-5 text-[#1A3A5F] mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Normas ISO</span>
                </li>
              </ul>
              <Link to="/normativas" className="text-[#1A3A5F] hover:text-[#4D8BC9] font-medium transition-colors">
                Ver todas as normativas →
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Nossos Serviços em Normativas</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Oferecemos uma ampla gama de serviços para auxiliar sua empresa a atender às exigências 
              normativas aplicáveis ao seu setor.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Serviço 1 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F] text-center">Diagnóstico de Conformidade</h3>
              <p className="text-gray-700 text-center">
                Avaliação completa da situação atual da empresa em relação às normas aplicáveis, 
                identificando não conformidades e oportunidades de melhoria.
              </p>
            </motion.div>

            {/* Serviço 2 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9] text-center">Elaboração de Documentação</h3>
              <p className="text-gray-700 text-center">
                Desenvolvimento de toda a documentação exigida pelas normas, como prontuários, 
                procedimentos operacionais, análises de risco e planos de ação.
              </p>
            </motion.div>

            {/* Serviço 3 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F] text-center">Implementação de Requisitos</h3>
              <p className="text-gray-700 text-center">
                Suporte na implementação prática dos requisitos normativos, incluindo adequação 
                de instalações, processos e sistemas de gestão.
              </p>
            </motion.div>

            {/* Serviço 4 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9] text-center">Treinamento e Capacitação</h3>
              <p className="text-gray-700 text-center">
                Programas de treinamento e capacitação para colaboradores, conforme exigido 
                pelas normas, com emissão de certificados reconhecidos.
              </p>
            </motion.div>

            {/* Serviço 5 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F] text-center">Auditorias Internas</h3>
              <p className="text-gray-700 text-center">
                Realização de auditorias internas para verificar o atendimento aos requisitos 
                normativos e identificar oportunidades de melhoria.
              </p>
            </motion.div>

            {/* Serviço 6 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-5 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9] text-center">Acompanhamento Contínuo</h3>
              <p className="text-gray-700 text-center">
                Monitoramento contínuo das atualizações normativas e suporte na implementação 
                das mudanças necessárias para manter a conformidade.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Benefícios dos Nossos Serviços</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Ao implementar nossos serviços de normativas técnicas, sua empresa obtém diversos benefícios 
              que impactam diretamente na segurança, conformidade e produtividade.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Benefício 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Conformidade Legal</h3>
              <p className="text-gray-700">
                Garantia de atendimento às exigências legais e normativas, evitando multas, 
                interdições e outras penalidades por parte dos órgãos fiscalizadores.
              </p>
            </motion.div>

            {/* Benefício 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Redução de Riscos</h3>
              <p className="text-gray-700">
                Minimização dos riscos de acidentes, incidentes e doenças ocupacionais, 
                protegendo a integridade física dos trabalhadores e das instalações.
              </p>
            </motion.div>

            {/* Benefício 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Aumento da Produtividade</h3>
              <p className="text-gray-700">
                Melhoria dos processos e condições de trabalho, resultando em maior 
                eficiência operacional e produtividade.
              </p>
            </motion.div>

            {/* Benefício 4 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Melhoria da Imagem</h3>
              <p className="text-gray-700">
                Fortalecimento da imagem da empresa perante clientes, fornecedores, 
                colaboradores e sociedade, demonstrando compromisso com a segurança e qualidade.
              </p>
            </motion.div>

            {/* Benefício 5 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Redução de Custos</h3>
              <p className="text-gray-700">
                Diminuição de custos relacionados a acidentes, paradas não programadas, 
                indenizações, processos judiciais e seguros.
              </p>
            </motion.div>

            {/* Benefício 6 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Vantagem Competitiva</h3>
              <p className="text-gray-700">
                Diferenciação no mercado, facilitando a participação em licitações, 
                concorrências e parcerias com empresas que exigem conformidade normativa.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1A3A5F] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Precisa de Serviços em Normativas Técnicas?</h2>
            <p className="text-xl mb-8">
              Entre em contato conosco e descubra como podemos ajudar sua empresa a garantir a conformidade 
              com as normas e regulamentos aplicáveis ao seu setor.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/contato" 
                className="bg-white text-[#1A3A5F] hover:bg-gray-100 font-bold px-8 py-3 rounded-md transition-colors"
              >
                Fale Conosco
              </Link>
              <Link 
                to="/servicos" 
                className="bg-transparent border-2 border-white hover:bg-white hover:text-[#1A3A5F] text-white font-bold px-8 py-3 rounded-md transition-colors"
              >
                Outros Serviços
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicoNormativasPage;
